<template>
    <div class="a-progress" v-if="showProgress" >
        <div class="a-progress__inner u-posRelative">
            <progress 
                class="a-progress__bar" 
                :value="current" 
                :max="total"
            ></progress>
            <div class="a-progress__percentage">
                <div class="a-progress__percentageBox">
                    {{ percentage }}%
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { calculateProgressPercentage } from '../../utils/globalFunctions';

const props = defineProps({
    current: {
        type: Number,
        default: 0
    },
    total: {
        type: Number,
        default: 0
    }
});

const showProgress = computed(() => props.current > 0 || props.total > 0);

const percentage = computed(() => {
    if (!showProgress.value) return 0;
    return calculateProgressPercentage(props.current, props.total);
});
</script>
